import Store from "./common/Store";
import { getDynamicData } from "./common/Store/actions/updateUserAndChatFromOrigin";

const userPageHistoryTracking = async (): Promise<{
  isError: boolean;
  error?: Error;
}> => {
  await getDynamicData;
  const { sessionId } = Store.getState().user;

  // Exit early if sessionId is missing
  if (!sessionId) {
    return { isError: false };
  }

  // Validate dataLayer
  if (!Array.isArray(window.dataLayer)) {
    return { isError: false }; // Gracefully handle invalid dataLayer
  }

  // Access the first element of the dataLayer array
  const dataLayerFirstElement =
    window.dataLayer && window.dataLayer.length > 0
      ? window.dataLayer[0]
      : null;

  // Initialize itemNumber, categoryId, and cleanUrl
  let itemNumber = null;
  let categoryId = null;
  let searchTerm = null;
  let specializedPageId = null;
  let relativeUrl: string | number | true = window.location.pathname; // Default to pathname if clean_url is not available

  // Extract itemNumber, categoryId, and relativeUrl based on dataLayer
  if (dataLayerFirstElement) {
    const pageType = dataLayerFirstElement.page_type;
    const pageValue = dataLayerFirstElement.page_value || null;
    relativeUrl = dataLayerFirstElement.clean_url || relativeUrl;

    // Ensure only one of itemNumber, categoryId, searchTerm, or specializedPageId is populated
    if (pageType === "product") {
      itemNumber = pageValue;
    } else if (pageType === "category") {
      categoryId = pageValue;
    } else if (pageType === "search") {
      searchTerm = dataLayerFirstElement.search_value;
    } else if (pageType === "specialized pages") {
      specializedPageId = pageValue;
    }
  }

  // If all values are null, do not make a fetch request
  if (!itemNumber && !categoryId && !searchTerm && !specializedPageId) {
    return { isError: false }; // Gracefully exit without making a fetch
  }

  // Prepare data for the fetch request
  const data = {
    sessionId,
    relativeUrl,
    itemNumber,
    categoryId,
    searchTerm,
    specializedPageId,
    dateViewed: Date.now(),
  };

  const url = new URL(
    "/api/userpagehistorytracking/logpageview",
    window.location.origin,
  );

  try {
    const result = await fetch(url.href, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });

    if (!result.ok) {
      return {
        isError: true,
        error: new Error(
          `User page history fetch error: "${result.statusText}"`,
        ),
      };
    }
    return { isError: false };
  } catch (error) {
    return {
      isError: true,
      error: new Error("User page history fetch error", { cause: error }),
    };
  }
};

export default userPageHistoryTracking;
